export default __webpack_public_path__ + "static/media/01_standard.a96e5d05.png";